import { render, staticRenderFns } from "./giftItem.vue?vue&type=template&id=74c2e38a&scoped=true&"
import script from "./giftItem.vue?vue&type=script&lang=js&"
export * from "./giftItem.vue?vue&type=script&lang=js&"
import style0 from "./giftItem.vue?vue&type=style&index=0&id=74c2e38a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2e38a",
  null
  
)

export default component.exports